import { render } from "./MonthPicker.vue?vue&type=template&id=161f1b72&scoped=true"
import script from "./MonthPicker.vue?vue&type=script&lang=js"
export * from "./MonthPicker.vue?vue&type=script&lang=js"

import "./MonthPicker.vue?vue&type=style&index=0&id=161f1b72&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161f1b72"]])

export default __exports__